import { render, staticRenderFns } from "./gl-header-report.vue?vue&type=template&id=4a7fd80e&scoped=true"
import script from "./gl-header-report.vue?vue&type=script&lang=js"
export * from "./gl-header-report.vue?vue&type=script&lang=js"
import style0 from "./gl-header-report.vue?vue&type=style&index=0&id=4a7fd80e&prod&lang=css"
import style1 from "./gl-header-report.vue?vue&type=style&index=1&id=4a7fd80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7fd80e",
  null
  
)

export default component.exports